import { gt } from '~/lib/gt'

import { Button } from '../Button/Button'

import styles from './CheckYourEmailModal.module.css'

interface CheckYourEmailModalViewProps {
  handleClose: () => void
}

const CheckYourEmailModalView = ({ handleClose }: CheckYourEmailModalViewProps) => {
  return (
    <div className={styles.checkYourEmailModal}>
      <h3 className={styles.h3}>{gt.tp('CheckYourEmailModal', 'Check your email')}</h3>
      <h6 className={styles.h6}>{gt.tp('CheckYourEmailModal', "We've sent a password reset link to your email address")}</h6>
      <Button className={styles.submitButton} type='submit' onClick={handleClose}>
        {gt.tp('ForgotPasswordModal', 'Okay, close')}
      </Button>
    </div>
  )
}

export default CheckYourEmailModalView
